import { getLedgerPayments } from "@api";
import { ClientTable, Badge, Drawer, PageHeader, PageTitle } from "@components";
import { formatAmount, formatDateTime } from "@utils";
import { useEffect, useState } from "react";
import { ledgerPaymentStatusColors } from "../common";
import LedgerPaymentDetails from "../displays/LedgerPaymentDetails";

const LedgerPayments = () => {
  const [payments, setPayments] = useState(null);
  const [paymentId, setPaymentId] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const data = await getLedgerPayments();
      setPayments(data);
    }

    fetchData();
  }, []);

  const reloadData = async () => {
    const data = await getLedgerPayments();
    setPayments(data);
  };

  const tableConfig = {
    key: "LedgerPayments",
    search: (x, s) =>
      x.accountCode.toUpperCase().includes(s.toUpperCase()) ||
      x.customerName.toUpperCase().includes(s.toUpperCase()) ||
      `${x.amount}`.includes(s),
    dateProperty: "triggeredOn",
    onClick: (x) => setPaymentId(x.id),
    colCustomisation: true,
    columns: [
      {
        title: "Payment Date",
        key: "paymentDate",
        id: "paymentDate",
        width: "120px",
        render: (x) => formatDateTime(x.paymentDate),
        sortFunc: (a, b) => new Date(a.paymentDate) - new Date(b.paymentDate),
        type: "date",
      },
      {
        title: "Account number",
        key: "accountCode",
        id: "accountCode",
        width: "100px",
        render: (x) => x.accountCode,
        sortFunc: (a, b) => (a.accountCode || "").localeCompare(b.accountCode),
        type: "string",
      },
      {
        title: "Customer name",
        key: "customerName",
        id: "customerName",
        width: "200px",
        render: (x) => x.customerName,
        sortFunc: (a, b) =>
          (a.customerName || "").localeCompare(b.customerName),
        type: "string",
      },
      {
        title: "Amount",
        key: "amount",
        id: "amount",
        width: "150px",
        right: true,
        render: (x) => formatAmount(x.amount),
        sortFunc: (a, b) => a.amount - b.amount,
      },
      {
        title: "Method",
        key: "paymentMethod",
        id: "paymentMethod",
        width: "180px",
        type: "enum",
        values: ["Pay by bank", "Card"],
        render: (x) => x.paymentMethod,
        renderFilter: (x) => x,
      },
      {
        title: "Status",
        key: "status",
        id: "status",
        width: "150px",
        render: (x) => (
          <Badge color={ledgerPaymentStatusColors[x.status]}>{x.status}</Badge>
        ),
        type: "enum",
        values: Object.keys(ledgerPaymentStatusColors),
      },
      {
        title: "Reconciled by",
        key: "reconciledBy",
        id: "reconciledBy",
        width: "200px",
        render: (x) => x.reconciledBy,
        type: "enum",
      },
    ],
  };

  return (
    <>
      <PageHeader>
        <PageTitle>Ledger</PageTitle>
      </PageHeader>
      <ClientTable config={tableConfig} data={payments} />
      <Drawer
        title="Payment details"
        toggle={() => setPaymentId(null)}
        isOpen={!!paymentId}
        size="md"
      >
        {paymentId && (
          <LedgerPaymentDetails
            paymentId={paymentId}
            onChanged={() => reloadData()}
          />
        )}
      </Drawer>
    </>
  );
};

export default LedgerPayments;
